<template>
  <div>
    <!-- 配货确认 -->
    <el-dialog :title="$t('message.distributionProcessed')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1880px" center>
      <div class="content">
        <!-- 列表 -->
        <div class="table">
          <ol>
            <!-- 选择 -->
            <li class="flex05">
              {{ $t("message.choose") }}
            </li>
            <!-- 序号 -->
            <li class="flex05">
              序号
            </li>
            <!--  订单号-->
            <li class="flex2">
              {{ $t("message.orderNumber") }}
            </li>
            <!-- 番号 -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!--照片-->
            <li>{{ $t("message.pic") }}</li>
            <!-- 业务编辑商品属性 -->
            <li class="flex2">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
            <!-- 附加服务  -->
            <li class="flex2">{{ $t("message.additionalServices") }}</li>
            <!-- 当前价格 -->
            <li>{{ $t("message.currentPrice") }}</li>
            <!-- 问题类别  -->
            <li>{{ $t("message.typeOfProblem") }}</li>
            <!-- 问题数 -->
            <li>{{ $t("message.numberOfProblems") }}</li>
            <!-- 问题图片 -->
            <li class="flex2">{{ $t("message.problemPic") }}</li>
            <!-- 待退款数量 -->
            <li class="flex2">{{ $t("message.pendingRefundQuantity") }}</li>
            <!-- 修改后附加服务 -->
            <li class="flex2">修改后option</li>
            <!-- 具体问题描述  -->
            <li class="flex2">{{ $t("message.specificProblemDescription") }}</li>
            <!-- 业务决策备注 -->
            <li class="flex2">{{ $t("message.businessDecisionRemarks") }}</li>
            <!-- FBA(配货)确认备注 -->
            <li class="flex2">FBA(配货)确认备注</li>
            <!-- 关联赔款单 -->
            <li class="flex2">{{ $t("message.relatedCompensationOrder") }}</li>
          </ol>
          <!-- 列表 -->
          <div class="detail" v-for="(item, index) in list" :key="index">
            <!-- 头部 -->
            <div class="head">
              <!-- 提出时间 -->
              <div class="item">
                <div>
                  <p>{{ $t("message.forwardTime") }}</p>
                  {{ item.created_at }}
                </div>
              </div>
              <!--提出人： -->
              <div class="item">
                {{ $t("message.peoplePutForward") }}:
                {{ item.created_by_realname }}
              </div>
            </div>
            <template v-if="item.show">
              <ul v-for="(items, indexs) in item.list" :key="indexs">
                <!-- 选择 -->
                <li class="flex05">
                  <label>
                    <el-checkbox v-model="items.checked" slot="reference"></el-checkbox>
                    <!-- <el-popover placement="right" title="合计" width="200" trigger="focus">
                    <statistics :checkList="checkList" />
                  </el-popover> -->
                  </label>
                </li>
                <!-- 序号 -->
                <li class="flex05">
                  {{ indexs + 1 }}
                </li>
                <!--  订单号-->
                <li class="flex2">
                  <router-link :to="'/orderPaymentDetail?order_sn=' + items.order_sn" target="_blank" class="a-link">
                    {{ items.order_sn }}
                  </router-link>
                </li>
                <!-- 番号 -->
                <li class="flex05">
                  {{ items.sorting }}
                </li>
                <!--照片-->
                <li>
                  <div class="img">
                    <el-popover placement="right" width="300" trigger="hover">
                      <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                      <a :href="items.link" target="_blank" slot="reference">
                        <img :src="items.pic" alt="" />
                      </a>
                    </el-popover>
                  </div>
                </li>
                <!-- 商品属性 -->
                <li class="flex2">
                  <div class="template">
                    <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                      <span>{{ skuItem.key }}:</span>
                      <span>{{ skuItem.value }}</span>
                    </p>
                  </div>
                </li>
                <!--附加服务  -->
                <li class="flex2">
                  <el-popover placement="bottom-start" width="500" trigger="click" v-if="items.option">
                    <el-table :data="items.option" border size="mini" show-summary max-height="500px">
                      <el-table-column property="name" label="附加服务(中文)" align="center"></el-table-column>
                      <el-table-column property="name_translate" label="附加服务(日文)" align="center"></el-table-column>
                      <el-table-column property="num" label="数量" align="center"></el-table-column>
                      <el-table-column label="单价" align="center">
                        <template slot-scope="scope">
                          {{ scope.row.price }} {{ scope.row.unit }}
                        </template>
                      </el-table-column>
                      <el-table-column property="unit" label="单位" align="center"></el-table-column>
                      <el-table-column label="小计.元" align="center" property="total">
                      </el-table-column>
                    </el-table>
                    <div class="template" slot="reference">
                      <div v-for="(opti, optis) in items.option" :key="optis" style="color: #2c96e7;">
                        <p>{{ optis + 1 }}, {{ opti.name }} * {{ opti.num }}x{{ opti.price }} {{ opti.unit }}</p>
                      </div>
                    </div>
                  </el-popover>
                </li>
                <!--当前价格 -->
                <li>
                  <div class="template">
                    <!-- 数量 -->
                    <p>{{ $t("message.number") }}:{{ items.confirm_num }}</p>
                    <!-- 价格 -->
                    <p>{{ $t("message.price") }}:{{ items.confirm_price }}</p>
                    <!-- 运费-->
                    <p>
                      {{ $t("message.freight") }}:{{ items.confirm_price }}
                    </p>
                  </div>
                </li>
                <!--问题类别  -->
                <li>{{ items.type_name }}</li>
                <!-- 问题产品数 -->
                <li>
                  {{ items.num }}
                </li>
                <!-- 问题图片 -->
                <li class="flex2">
                  <div class="imgList">
                    <div class="imgs" v-for="(imgs, imgIndex) in items.in_sale_image" :key="imgIndex">
                      <el-image v-if="imgs.image"
                        :src="imgs.isOss ? imgs.image + '?x-oss-process=image/resize,p_10' : imgs.image"
                        :preview-src-list="[imgs.image]">
                      </el-image>
                      <!-- <img src="@/assets/icon/eye.png" alt="" class="el-icon-open" v-if="imgs.client_show"> -->
                    </div>
                  </div>
                </li>
                <!-- 待退款数量 -->
                <li class="flex2">
                  <span style="color:#B4272D; ">
                    {{ $t("message.pendingRefundQuantity") }}： {{ items.new_num }}
                  </span>
                </li>
                <!-- 修改后附加服务  -->
                <li class="flex2">
                  <el-popover placement="bottom-start" width="500" trigger="click" v-if="items.new_option">
                    <el-table :data="items.new_option" border size="mini" show-summary>
                      <el-table-column property="name" label="附加服务(中文)" align="center"></el-table-column>
                      <el-table-column property="name_translate" label="附加服务(日文)" align="center"></el-table-column>
                      <el-table-column property="num" label="数量" align="center"></el-table-column>
                      <el-table-column label="单价" align="center">
                        <template slot-scope="scope">
                          {{ scope.row.price }} {{ scope.row.unit }}
                        </template>
                      </el-table-column>
                      <el-table-column property="unit" label="单位" align="center"></el-table-column>
                      <el-table-column label="小计.元" align="center" property="total">
                      </el-table-column>
                    </el-table>
                    <div class="template" slot="reference">
                      <div v-for="(opti, optis) in items.new_option" :key="optis" style="color: #2c96e7;">
                        <p>{{ optis + 1 }}, {{ opti.name }} * {{ opti.num }}x{{ opti.price }} {{ opti.unit }}</p>
                      </div>
                    </div>
                  </el-popover>
                </li>
                <!-- 具体问题描述 -->
                <li class="flex2 remark-border">
                  {{ items.description }}
                </li>
                <!-- 业务决策备注 -->
                <li class="flex2 remark-border" style="border-left:0">
                  {{ items.y_deal }}
                </li>
                <!-- 业务决策备注 -->
                <li class="flex2 ">
                  <el-input type="textarea" v-model="items.p_deal" @blur="updatePDealRemark(items)" maxlength="200"
                    @input="allText('p_deal', items.p_deal, items.checked)"></el-input>
                </li>
                <!-- 关联赔款单 -->
                <li class="flex2 ">
                  <div class="template">
                    <div class="row" v-for="(reparation, reparationIndex) in items.reparation" :key="reparationIndex">
                      <div class="pk ">
                        <router-link :to="'/reparationList?reparation_sn=' + reparation.reparation_sn" target="_blank"
                          class="a-link">
                          {{ reparation.reparation_sn }}
                        </router-link>
                      </div>
                      <div class="status">{{ reparation.status_name }}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </template>
            <!-- </div> -->
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="foot">
        <div class="left">
          <!-- 全选 -->
          <el-checkbox v-model="checked" @change="allChecked">
            {{ $t("message.allChecked") }}
          </el-checkbox>
        </div>
        <div class="right">
          <el-button type="primary" @click="pDeal">提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    list: { type: Array }
  },
  data() {
    return {
      dialogVisible: false,
      checked: false,
      is_need_confirm: '1'
    };
  },
  methods: {
    // 保存
    save() {
      let datas = {
        ids: [],
        new_num: this.new_num,
      };
      this.checkList.forEach(item => {
        datas.ids.push(item.id)
      })
      if (!this.new_num) return this.$message.error('请输入待退款数量')
      this.$api.inSaleApi.updateNewNum(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.inSaleList()
      });
    },
    //  全选
    allChecked() {
      this.list.forEach((item) => {
        item.checked = this.checked;
        item.list.forEach((items) => {
          items.checked = this.checked;
        });
      });
      this.$forceUpdate();
    },
    //待决策临时备注
    updatePDealRemark(data) {
      let datas = {
        ids: [],
        p_deal: data.p_deal
      }
      if (data.checked) {
        this.list.forEach((item) => {
          item.list.forEach((items) => {
            if (items.checked) {
              datas.ids.push(items.id)
            }
          });
        });
      } else {
        datas.ids = [data.id]
      }
      this.$api.inSaleApi.updatePDealRemark(datas)
    },
    //配货确认
    pDeal() {
      let datas = {
        list: [],
      }
      this.list.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            datas.list.push({
              id: items.id,
              p_deal: items.p_deal
            })
          }
        });
      });
      this.$api.inSaleApi.pDeal(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.inSaleList()
      })
    },
    //批量修改
    allText(tpye, text, checked) {
      if (checked) {
        this.list.forEach(item => {
          item.list.forEach(items => {
            if (items.checked) {
              items[tpye] = text
            }

          })
        })
      }

      this.$forceUpdate()
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .table {
    ol {
      display: flex;
      font-size: 14px;
      height: 40px;
      background: #edeff4;
      color: #333;
      position: sticky !important;
      top: 0;
      left: 0;
      z-index: 999;
    }

    ul {
      display: flex;
      border-bottom: 1px solid #e8e8e8;
      padding: 10px 0;
      font-size: 12px;
      transition: 0.25s;

      &:hover {
        background-color: #eee;
        cursor: pointer;
      }

      li {
        width: 100%;
        overflow: hidden;
        //   max-height: 80px;

        .template {
          text-align: left;
          width: 100%;
          max-height: 120px;
          overflow-y: auto;

          p {
            line-height: 20px;
          }
        }

        .scope {
          max-height: 100px;

          p {
            line-height: 20px;
          }
        }

        .imgList {
          display: flex;
          flex-wrap: wrap;

          .imgs {
            margin: 0 10px 10px 0;
            position: relative;
            height: 50px;

            .index {
              position: absolute;
              top: -0px;
              left: -0px;
              width: 15px;
              height: 15px;
              background-color: #B4272D;
              border-radius: 50%;
              text-align: center;
              line-height: 15px;
              color: #fff;
              z-index: 99;
            }

            .el-icon-open {
              position: absolute;
              bottom: 0px;
              right: 0;
              width: 18px;
              padding: 0;
            }

            &:nth-child(even) {
              margin-right: 0;
            }

            &:nth-child(n + 2) {
              margin-bottom: 0;
            }


          }
        }
      }



      .img {
        img {
          width: 60px;
          height: 60px;
          border-radius: 4px;
        }
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0 3px;

      /deep/ .el-textarea__inner {
        min-height: 70px !important;
        resize: none;
        padding: 3px;
      }

      label {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .el-image {
        height: 50px;
        width: 50px;
        border-radius: 4px;
      }
    }

    .flex05 {
      flex: 0.5;
      position: relative;

      .chong {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        text-align: center;
        line-height: 25px;
        color: #fff;
        position: absolute;
        top: 50%;
        left: 20px;
        background-color: #2C96E7;
      }
    }

    .flex15 {
      flex: 1.3;
    }

    .flex2 {
      flex: 1.8;
    }

    .remark-border {
      border: 1px solid #ccc;

      display: block;
      text-align: left;
      word-break: break-all;
    }

    .important {
      background-color: #fee0c3;
    }

    .detail {

      .head {
        height: 50px;
        display: flex;
        background: #7080b1;
        font-size: 14px;
        padding: 0 20px;
        color: #fff;
        margin: 5px 0;

        .inco {
          margin-right: 24px;
          display: flex;
          align-items: center;
          font-size: 20px;
          cursor: pointer;
        }

        .item {
          display: flex;
          align-items: center;
          width: 280px;
          line-height: 20px;
        }

        .problem {
          display: inline-block;
          width: 28px;
          height: 28px;
          background-color: #B4272D;
          vertical-align: middle;
          text-align: center;
          line-height: 28px;
          border-radius: 50%;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }

    .noData {
      padding: 20px 0;
      text-align: center;
    }

    .trading {
      padding: 12px;
      background-color: #dedeef;
      color: #000;
      position: relative;

      a {
        color: #000;
      }

      span {
        margin-left: 20px;
      }

      .urgent {
        position: absolute;
        top: 5px;
        right: 5px;
      }

      .prompt {
        color: #B4272D;
        font-size: 20px;
        font-weight: 600;
      }
    }

    .template {
      .row {
        margin-bottom: 10px;

        .status {
          display: flex;
          justify-content: space-between;

          i {
            font-size: 20px;
            margin-right: 5px;
            vertical-align: middle;
            color: #000;
          }
        }
      }
    }

  }

}

.foot {
  display: flex;
  justify-content: space-between;
  padding: 50px 0 20px;

  span {
    color: #B4272D;
  }

  .left {
    padding-left: 30px;

    span {
      margin-left: 30px;
    }
  }

  .right {
    span {
      margin-right: 20px;
      color: #F56C6C;
    }
  }
}
</style>